export const CCPA_ANALYTICS = "gn_ccpa_analytics";
export const CCPA_MARKETING = "gn_ccpa_marketing";
export const CCPA_PERSONALIZATION = "gn_ccpa_personalization";
export const ACCESSIBILITY = "gn_accessibility";
